import React from "react";


function Developers() {
  return (
    <div className="developers">
      <div class="container">
        <div class="row align-items-center my-5">
          <div class="col-lg-7">
            
            <img
              class=""
              src="https://sketchfab.com/3d-models/tyrannosaurus-rex-9d3a3e42c0054c35aa39c3ee07388d16"
              alt=""
            />
          </div>
          <div class="col-lg-5">
            <h1 class="font-weight-light">Developers</h1>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Developers;